import React from 'react'
import { PageContent, ModalLayer, IconButton } from '@ui'
import Appbar from 'components/Appbar'
import { useReload } from '@hooks/reloadContext'
import { Router, RouteComponentProps } from '@reach/router'
import { navigateWithBasepath } from '../../App'
import TableView from './TableView'
import useSpaceTypes from './hooks/useSpaceTypes'
import SpaceTypeSearch from './SpaceTypeSearch'
import { legacyMode } from 'App'
import { navigateToAphrodite } from '@utils/navigateToAphrodite'

export default function SpaceTypeManagement({ navigate }: RouteComponentProps) {
  const reload = useReload()
  const spaceTypes = useSpaceTypes()
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" reload={reload.spaceTypes} />
      </Router>
      <Appbar
        title={
          legacyMode ? (
            <div className="flex items-center">
              <span className="mr-2">
                <IconButton
                  minimal
                  iconName="chevron-left"
                  onClick={() => navigateToAphrodite('/settings')}
                />
              </span>
              Space Types
            </div>
          ) : (
            'Space Types'
          )
        }
      >
        <SpaceTypeSearch hook={spaceTypes} navigate={navigate} />
      </Appbar>

      <PageContent>
        <TableView spaceTypes={spaceTypes} navigate={navigate} />
      </PageContent>
    </>
  )
}
